import React from "react";
import PropTypes from "prop-types";
import styles from "components/notifications.scss";
import { Link } from "react-router";
import FaDocument from "react-icons/fa/file-text-o";
import FaCloudUpload from "react-icons/fa/cloud-upload";
import FaExclamationTriangle from "react-icons/fa/exclamation-triangle";
import { DropdownModal } from "components/common/dropdown-modal";
import { pluralize } from "utils/string-helpers";

export const Notifications = ({
  accountSlug,
  exportFailedCount,
  isNotificationsMode,
  onEndNotificationsMode,
  pendingDocumentsCount,
  queuedCount
}) => (
  <DropdownModal
    arrowSide
    offsetLeft={ -150 }
    offsetTop={ 30 }
    onClose={ onEndNotificationsMode }
    visible={ isNotificationsMode }
    width={ 250 }
  >
    <div className={ styles.container }>
      <Link to={ `/accounts/${accountSlug}/awaiting-digital` }>
        <FaDocument className={ styles.icon } size={ 15 } />
        { pluralize(pendingDocumentsCount, "documents", "document") } awaiting processing
      </Link>
      <Link to={ `/accounts/${accountSlug}/documents/filter/category=Queued for Export` }>
        <FaCloudUpload className={ styles.icon } size={ 15 } />
        {pluralize(queuedCount, "documents", "document")} queued for export
      </Link>
      <Link to={ `/accounts/${accountSlug}/documents/filter/category=Export failed` }>
        <FaExclamationTriangle className={ styles.icon } size={ 15 } />
        {pluralize(exportFailedCount, "documents", "document")} failed to export
      </Link>
    </div>
  </DropdownModal>
);

Notifications.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  exportFailedCount: PropTypes.number.isRequired,
  isNotificationsMode: PropTypes.bool.isRequired,
  onEndNotificationsMode: PropTypes.func.isRequired,
  pendingDocumentsCount: PropTypes.number.isRequired,
  queuedCount: PropTypes.number.isRequired
};




// WEBPACK FOOTER //
// ./src/js/components/notifications.jsx